const appId = import.meta.env.VITE_INTERCOM_APP_ID
const config = { appId }

export default config
